"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequest = void 0;
var requestStatus_1 = require("./requestStatus");
var useRequestState_1 = require("./useRequestState");
/**
 * Returns a request state and a callback to trigger the request
 * @param func API method call to call when request has been triggered
 */
function useRequest(func) {
    var _this = this;
    var _a = useRequestState_1.useRequestState(), state = _a[0], setState = _a[1];
    var request = function () {
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var startTime, response, state_1, err_1, state_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startTime = new Date().toISOString();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        setState({
                            type: requestStatus_1.RequestStatus.Pending,
                            startTime: startTime,
                            requestPayload: parameters,
                        });
                        return [4 /*yield*/, func.apply(void 0, parameters)];
                    case 2:
                        response = _a.sent();
                        state_1 = {
                            type: requestStatus_1.RequestStatus.Complete,
                            startTime: startTime,
                            endTime: new Date().toISOString(),
                            requestPayload: parameters,
                            responsePayload: response,
                        };
                        setState(state_1);
                        return [2 /*return*/, state_1];
                    case 3:
                        err_1 = _a.sent();
                        state_2 = {
                            type: requestStatus_1.RequestStatus.Error,
                            startTime: startTime,
                            endTime: new Date().toISOString(),
                            requestPayload: parameters,
                            error: err_1,
                        };
                        setState(state_2);
                        return [2 /*return*/, state_2];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return [state, request];
}
exports.useRequest = useRequest;
